import settings from "../../../configs/settings";
import { Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { useContext, useState } from "react";
import ArregloEstadoDialog from "./ArregloEstadoDialog";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"

//
// ################################################################################
//
const ArregloTable = () => {
  const [openArregloEstadoDialog, setOpenArregloEstadoDialog] = useState(false);
  const [idArreglo, setIdArreglo] = useState("");
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const {
    arreglos,
    arreglosSelected,
    obtenerArreglo,
    quitarArreglo,
    arregloAction,
    seleccionarArreglos,
    totalArreglos,
    totalArreglosContado,
    showCheckBoxesArreglosRows,
    showActionsArreglosRows,
    showImportesContado,
    gaAction,
  } = useContext(GestionAtencionContext);

  const tableColumns = [
    {
      field: "codigoArreglo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigoArreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojoCristalesDescripcion",
      headerName: "Descripción del arreglo",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoCristalesDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "totalArreglo",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.totalArreglo.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "totalArregloContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.totalArregloContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu === "view" && (
            <>
              <Tooltip title="ver arreglo">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => obtenerArreglo(params.row, "view")}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {gaAction.cu !== "view" && showActionsArreglosRows && (
            <>
              {arregloAction.cu === "new" ? (
                <>
                  <Tooltip title="actualizar">
                    <IconButton
                      size="small"
                      aria-label="update"
                      onClick={() => obtenerArreglo(params.row, "update")}
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="quitar">
                    <IconButton
                      size="small"
                      aria-label="delete"
                      onClick={() => quitarArreglo(params.row)}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <>
                  <IconButton size="small" disabled={true} aria-label="update">
                    <EditOutlinedIcon />
                  </IconButton>
                  <IconButton size="small" disabled={true} aria-label="delete">
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </>
              )}
            </>
          )}

          {gaAction.cu === "view" &&
            params.row.actionEstadoArreglo === "venta-concretada" && (
              <>
                <Tooltip title="estado del arreglo">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => handleClickArregloEstado(params.row)}
                  >
                    <PublishedWithChangesOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickArregloEstado = (parRow) => {
    setIdArreglo(parRow.id);
    setOpenArregloEstadoDialog(true);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={3} sx={{ m: 1, p: 2 }}>
        <DataGrid
          rows={arreglos}
          columns={tableColumns}
          {...tableOptions}
          checkboxSelection={showCheckBoxesArreglosRows}
          rowSelectionModel={showCheckBoxesArreglosRows ? arreglosSelected : []}
          onRowSelectionModelChange={(newSelection) => {
            seleccionarArreglos(newSelection);
          }}
        />

        <Grid container spacing={1}>
          <Grid item sm={showImportesContado ? 6 : 12}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "SteelBlue",
                borderRadius: "5px",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              TOTAL DE LISTA: {formatMoney(totalArreglos)}
            </Typography>
          </Grid>

          {showImportesContado ? (
            <>
              <Grid item sm={6}>
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "SteelBlue",
                    borderRadius: "5px",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                  }}
                >
                  TOTAL DE CONTADO: {formatMoney(totalArreglosContado)}
                </Typography>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Paper>

      {/* >>>> Dialog */}

      {openArregloEstadoDialog && (
        <ArregloEstadoDialog
          idGestionAtencionArreglo={idArreglo}
          onClose={() => setOpenArregloEstadoDialog(false)}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}
    </>
  );
};
export default ArregloTable;